<script>
import AppHeader from '@/components/AppHeader'
import AccountModal from '@/components/AccountModal'
import AppFooter from '@/components/AppFooter'
import AppNavigator from '@/components/AppNavigator.vue'

export default {
  name: 'app',
  components: {
    AppHeader,
    AccountModal,
    AppFooter,
    AppNavigator
  },
  data: function() {
    return {
      headerConfig: {
        title: 'ARM Metrics Dashboard',
        subtitle: 'ARM Metrics'
      },
      headerButtons: [
        {
          text: 'My Account',
          image: 'accountIcon',
          //path: "/logout",
          size: 20,
          disabled: false,
          modal: 'account-modal'
        }
      ],
      collapsed: false
    }
  },
  computed: {
    showCheckingLogin: function() {
      return this.$store.state.checkingLogin
    },
    collapsedClass() {
      return {
        collapsed: this.collapsed,
        notCollapsed: !this.collapsed
      }
    },
    standalonePage() {
      let isStandalone = false
      if (this.$route.meta && this.$route.meta.standalone) {
        isStandalone = true
        if (this.$route.meta.override) {
          if (this.$route.query[this.$route.meta.override]) {
            if (
              !this.$route.meta.overrideInfrastructure ||
              /base_role=postgraphile_infrastructure/.test(
                this.$store.state.role
              )
            ) {
              isStandalone = false
            }
          }
        }
      }
      return isStandalone
    }
  },
  methods: {
    onToggleCollapse() {
      this.collapsed = !this.collapsed
    }
  },
  created: function() {
    document.title = this.headerConfig.title
  }
}
</script>

<template>
  <div id="app" class="printable">
    <FormActionPopups
      ref="formActions"
      :showSaving="showSaving"
      :showSuccess="showSuccess"
      :showDelete="showDelete"
      @saveSuccessDismissed="successDismissed"
      @deleteSuccessDismissed="successDismissed"
    />
    <b-alert
      v-model="showCheckingLogin"
      class="position-fixed fixed-top m-0 rounded-0 h-100"
      style="z-index: 2001;"
      variant="primary"
      >Checking Login...</b-alert
    >
    <div v-if="!standalonePage">
      <AppHeader
        :buttons="headerButtons"
        title="Metrics Dashboard"
        :hideIndicators="true"
      />
      <b-container id="content" fluid>
        <b-row class="gContainer">
          <b-col :class="collapsedClass" class="gContainer p-0">
            <AppNavigator
              :collapsed="collapsed"
              @toggleCollapse="onToggleCollapse"
            />
          </b-col>
          <b-col :class="collapsedClass" class="gContainer gContent p-0">
            <router-view />
          </b-col>
        </b-row>
      </b-container>
      <AppFooter />
      <AccountModal />
      <ScrollToTop />
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<style>
/*
html {
  font-family: 'Proxima Nova';
  overflow-x: hidden;
  background-color: #194173;
}

#app {
  color: #414141;
  background-color: #194173;
}

.info-circle {
  font-size: 0.5em;
  vertical-align: super;
}

.under-development {
  font-style: italic;
  font-weight: bold;
  font-size: 1em;
  background-color: #bea600;
  padding: 4px;
  color: white;
  font-size: 0.6em;
}

.page {
  margin: 0 auto;
  width: 95% !important;
}

#content {
  padding: 2.5em !important;
  background-color: white;
}

.container {
  padding: 0 !important;
}

#navigation {
  background-color: #333;
  padding: 12px;
}

.navigation-link {
  padding-right: 12px;
  color: white;
}

.paginator {
  text-align: center;
  margin-bottom: 12px;
}

.x-slide-enter-active,
.x-slide-leave-active,
.y-slide-enter-active {
  transition: all 0.3s ease;
}

.x-slide-leave-to {
  transform: translateX(-10%);
  opacity: 0;
}

.x-slide-enter {
  transform: translateX(10%);
  opacity: 0;
}

.y-slide-enter {
  transform: translateY(10%);
  opacity: 0;
}

.inset_1 {
  margin: 0 auto;
  padding-bottom: 2.5em;
  max-width: 80%;
}

.inset_2 {
  margin: 0 auto;
  padding-bottom: 2.5em;
  max-width: 70%;
}

.overview h3 {
  font-size: 2.6em;
  font-weight: bold;
}

.modal-open {
  padding-right: 0 !important;
}

.masonry-card {
  border-radius: 0 !important;
  border: 0 !important;
}

.card-columns .card {
  margin-top: 0.75rem !important;
  margin-bottom: 0 !important;
}

.card-header {
  background-color: initial !important;
  padding: 1rem 1rem 0 1rem !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.card-text {
  height: 40px !important;
  padding: 0 1rem 1rem 1rem !important;
  margin: 0 !important;
}

.card-body,
.card-title {
  padding: 0 !important;
  margin: 0 !important;
}

.card-footer {
  font-size: 2em;
  color: #414141;
  text-align: right;
  border: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.masonry-card:hover {
  cursor: pointer;
}

#search {
  height: 60px;
  padding-left: 19px;
  border: 1px solid #979797 !important;
  border-right: none !important;
}

.search-input {
  margin: 0 auto 12px auto;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.search-icon-wrapper {
  font-size: 2em;
  padding-right: 30px;
  padding-left: 30px;
  border: 1px solid #979797 !important;
  border-left: none !important;
  line-height: 58px;
}

.button {
  height: 58px;
  line-height: 46px !important;
  min-width: 255px;
  border: none !important;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
  color: white !important;
  font-weight: bold !important;
  background-color: #194173 !important;
  vertical-align: middle;
}

.field {
  height: 58px;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.link {
  font-size: 1.6em;
}

.button:hover,
.link:hover {
  cursor: pointer;
}

code {
  color: darkorange !important;
}

.form-group-error input,
.form-group-error select,
.form-group-error textarea {
  border-color: rgb(255, 0, 0);
}

select:disabled {
  background: none;
  color: #121212 !important;
}

.item-remove-icon-wrapper,
.item-select-icon-wrapper,
.item-link-icon-wrapper,
.item-edit-icon-wrapper {
  text-align: center;
}

.item-remove-icon,
.item-select-icon,
.item-link-icon,
.item-edit-icon {
  color: #00bc70;
  font-size: 2em;
  cursor: pointer;
}
.item-link-icon {
  color: #757575;
}
.item-remove-icon {
  color: #a10505;
}

.scroll-to-top {
  position: fixed;
  bottom: 2em;
  right: 0;
  z-index: 2000;
}
.scroll-to-top .background {
  background-color: #00bd70 !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer !important;
}
*/
html,
html > body {
  background-color: #f1f5fb;
  font-family: 'Proxima Nova';
}
#content {
  display: flex;
  flex-flow: column;
  min-height: calc(
    100vh - 85px - 112px
  ); /* VH - Header Height - Footer Height */
  /*overflow: hidden;*/
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
}
#content > .row > .col-1,
#content > .row > .col-2,
#content > .row > .col-3,
#content > .row > .col-4,
#content > .row > .col-5,
#content > .row > .col-6,
#content > .row > .col-7,
#content > .row > .col-8,
#content > .row > .col-9,
#content > .row > .col-10,
#content > .row > .col-11,
#content > .row > .col-12 {
  padding-left: 0px;
  padding-right: 0px;
}
.gContainer {
  flex: 1 1 auto;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.gContainer.collapsed {
  max-width: 64px;
  margin-right: -64px !important;
}
.gContainer.notCollapsed {
  /*position: absolute;
  left: 0px;
  top: 85px;
  bottom: 112px;*/
  width: 400px;
  max-width: 400px;
}
.gContainer.notCollapsed.gContent {
  /*position: absolute;
  left: 400px;*/
  width: 100%;
  max-width: calc(100% - 400px);
}
.gContainer.collapsed.gContent {
  /*position: absolute;*/
  left: 64px;
  width: 100%;
  max-width: calc(100% - 64px);
}
.PageTopBar {
  width: 100%;
  min-height: 53px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  background-color: #0c2544;
  background: linear-gradient(180deg, #0b2544 0%, #194173 12.52%, #032548 100%);
}
.PageContent {
  padding: 10px;
}
/* Gets rid of the blue boxes chrome puts on everything that has focus */
:focus,
.focus {
  outline: none !important;
  box-shadow: none !important;
}
/********************************************
  Pagination Overrides
********************************************/
ul.pagination .page-item.active .page-link {
  background-color: #00bc70;
  border-color: #00bc70;
}
ul.pagination .page-link:focus {
  outline: none;
  box-shadow: none;
}
.updateAvailButton {
  position: absolute;
  top: 17px;
  right: 90px;
  z-index: 10px;
}
.push {
  height: 112px;
}
.wrapper {
  min-height: 100%;
  margin-bottom: -112px;
  /*background-color: #fff;*/
  background-color: #fff;
  background-image: linear-gradient(to top, hsla(0, 0%, 100%, 0.2), #fff),
    url(assets/bg.jpg);
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}
.row {
  width: 100%;
}
.item-edit-icon-wrapper,
.item-remove-icon-wrapper {
  text-align: center;
}
.item-edit-icon {
  color: #00bc70;
  font-size: 1.5em !important;
  cursor: pointer;
}
.item-remove-icon {
  color: #b22222;
  font-size: 1.5em !important;
  cursor: pointer;
}
.form-group-error input:not(:disabled):not(:read-only),
.form-group-error select:not(:disabled):not(:read-only),
.form-group-error .multiselect .multiselect__tags,
.form-group-error textarea:not(:disabled):not(:read-only),
.form-group-error div[role='radiogroup'] {
  border-color: rgb(255, 0, 0);
}
.form-group-error div[role='radiogroup'] {
  border-width: 1px;
  border-style: solid;
  padding: 0px 5px;
  border-radius: 5px;
}

.form-group-error.form-group-required .required-asterisk {
  color: rgb(255, 0, 0);
}

.scroll-to-top .row {
  max-width: 100px;
}

.typeahead {
  margin-left: 15px;
}

.report-details-only {
  display: none;
}
</style>
